import { render, staticRenderFns } from "./afterOrderList.vue?vue&type=template&id=5086f98c&scoped=true"
import script from "./afterOrderList.vue?vue&type=script&lang=js"
export * from "./afterOrderList.vue?vue&type=script&lang=js"
import style0 from "./afterOrderList.vue?vue&type=style&index=0&id=5086f98c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086f98c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5086f98c')) {
      api.createRecord('5086f98c', component.options)
    } else {
      api.reload('5086f98c', component.options)
    }
    module.hot.accept("./afterOrderList.vue?vue&type=template&id=5086f98c&scoped=true", function () {
      api.rerender('5086f98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/afterSale/afterOrderList.vue"
export default component.exports